module.exports = __webpack_public_path__ + "img/playBtn.a4a9eaeb.svg";